/**
 * How the other side is TOLD there is something to read. The message itself
 * never leaves the app, so this only ever picks between an in-app
 * notification, a Slack ping, and a link to paste somewhere yourself.
 */
import type { TFunction } from 'i18next';
import type { StocktakeNotifyConfig } from '@threadheads/shared';

/** Short label for the composer hint, e.g. "Slack #threadlab-ops". */
export function notifyLabelFor(config: StocktakeNotifyConfig, t: TFunction): string {
  if (config.mode === 'slack') {
    return t('stocktakes.notify.slackLabel', { channel: config.channel ?? '' });
  }
  if (config.mode === 'copy') return t('stocktakes.notify.copyLabel');
  return t('stocktakes.notify.inAppLabel');
}
